import React, { memo } from 'react';

import { Title } from '@components/Title';

import { useThemeGetter } from '@hooks';

import { SiteIcon } from '@assets/icons';

import {
  IconContainer,
  TextContainer,
  PaddingContainer,
  AnimatedLinkContainer,
} from './AnimatedLink.styled';

import { AnimatedLinkProps } from './AnimatedLink.types';

export const AnimatedLink = memo(
  ({ icon = <SiteIcon />, link }: AnimatedLinkProps) => {
    const {
      theme: { ElementShadow, Secondary, Background, Title: TitleColor },
    } = useThemeGetter();

    return (
      <AnimatedLinkContainer
        elementShadow={ElementShadow}
        secondary={Secondary}
        background={Background}
        target="_tab"
        href={link}
      >
        <TextContainer className="textBody">
          <PaddingContainer>
            <Title
              text="Visite site"
              color={TitleColor}
              size={2}
              cursor="pointer"
            />
          </PaddingContainer>
        </TextContainer>
        <IconContainer secondary={Secondary} className="linkIcon">
          {icon}
        </IconContainer>
      </AnimatedLinkContainer>
    );
  },
);
